import type { SanityFormConfirmation } from '#/lib/sanity/queries/formConfirmation';
import { Button } from '#/components/Button';
import { Headline } from '#/components/Headline';

type Props = {
  confirmation: SanityFormConfirmation | string;
  /** Surface theme for the CTA — use `dark` on purple/charcoal bands. */
  theme?: 'light' | 'dark';
};
export function FormConfirmation(props: Props) {
  let confirmation = props.confirmation;
  if (typeof confirmation === 'string') {
    confirmation = { bodyCopy: confirmation };
  }
  return (
    <div data-testid="form-confirmation">
      {confirmation.headline ? (
        <Headline value={confirmation.headline} variant={5} />
      ) : null}

      <p className="text-body mt-15 !text-current">{confirmation.bodyCopy}</p>
      {confirmation.cta?.href ? (
        <Button
          className="mt-20"
          href={confirmation.cta.href}
          target={confirmation.cta.target}
          variant="secondary"
          theme={props.theme}
        >
          {confirmation.cta.title}
        </Button>
      ) : null}
    </div>
  );
}
